module.exports = __webpack_public_path__ + "static/media/pfp-reckful.6a4c7fc9.jpeg";